import { useQuery } from '@tanstack/react-query';
import { useAccessToken } from '../auth/AccessTokenContext';
import { getApiV1AnalogueModels } from '../api/generated';
import { queryKeys } from './queryKeys';

export const useFetchAnalogueModels = () => {
  const token = useAccessToken();

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.analogueModels(),
    queryFn: () =>
      getApiV1AnalogueModels({
        query: {
          expand:
            'outcrops, stratigraphicgroups, fileuploads, modelareas, geologicalgroups, inifile',
        },
      }),
    select: (res) => res.data?.data ?? [],
    enabled: !!token,
    refetchInterval: 60000,
  });
};
